import React from 'react';
import useMain from '../../../../hooks/useMain';
import { WalletCard } from '../../ingredients/cards';

const Wallets = () => {
	const { initData, userData } = useMain();
	const wallets = Object.keys(initData.wallets);
	const bcn_usdt_rate = 1 / initData.bcn_price_usd;
	return (
		<div className='row'>
			{wallets.map((w, key) => {
				return (
					<div
						key={key}
						className='col-xl-3 col-lg-6'>
						<WalletCard
							wallet={w}
							title={initData.wallets[w].name}
							amount={userData.wallets[w].available / 1e6}
							bcn_usdt_rate={bcn_usdt_rate}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default Wallets;
